import React, { useState, useEffect } from 'react';
import { useDispatch, connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { DatePicker } from '@mui/x-date-pickers';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { GroupBox, SelectDs, SelectPlus, hooks } from 'lib.front';
import { transformacion, validacion, cadenas } from 'lib.common';

import useMensajeLlave from '../../../common/useMensajeLlave';
import { urlsCrm } from '../../../config/keys';
import { esquemaCampos, esquemaValidacion } from './esquemas';
import {
   queryData,
   queryGrupoCliente,
   mutationGenerarLicencia,
   queryDataPre,
   queryDataVer
} from './queries';
import { showSucces } from 'src/common/toast';
import { loadingModal, openMsg } from 'src/redux-app';
import { cmps } from './constantes';

const { denominacionCliente } = transformacion;
const { useValidacion, useApolloQ, useApolloLazyQ, useApolloMutation } = hooks;

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2)
   },
   tabla: {
      maxHeight: '250px'
   }
}));

const tiposDocumento = ['01', '03'];

function genValue(reg) {
   return reg.codigo;
}
function genLabel(reg) {
   return reg.denominacion;
}
function genId(reg) {
   return reg.codigo;
}

function GenerarLicencia({ usuario }) {
   const dispatch = useDispatch();
   const { classes, cx } = useStyles();
   //Modal de espera
   function openWaitModal(load) {
      dispatch(loadingModal(load));
   }
   //Modal para mensajes
   function openMsgModal(msg) {
      dispatch(openMsg(msg));
   }
   //Estados
   const {
      campos,
      existeError,
      handleOnChange,
      validacionManual,
      setCampo,
      validarTodos,
      inicializar
   } = useValidacion(esquemaCampos, esquemaValidacion);
   const [email, setEmail] = useState('');
   function onBlurValidacion(e) {
      validacionManual(e.target.name, e.target.value);
   }
   useEffect(() => {
      if (campos.cliente.valor && campos.cliente.valor.label) {
         setCampo('razonSocial', campos.cliente.valor.label.split('-')[1].trimStart());
      }
   }, [campos.cliente.valor]);

   //Data Generica
   const [productos, setProductos] = useState([]);
   const [versiones, setVersiones] = useState([]);
   const [presentaciones, setPresentaciones] = useState([]);
   const [modulares, setModulares] = useState([]);

   const [disable, setDisable] = useState(true);
   function procesarDataGenerica(data) {
      if (data['productos'] && data['productos'].length > 0) {
         setProductos(data['productos']);
         setCampo('producto', data['productos'][0].codigo);
      }
      if (data['presentaciones'] && data['presentaciones'].length > 0) {
         setPresentaciones(data['presentaciones']);
         setCampo('presentacion', data['presentaciones'][0].codigo);
      }
      if (data['versiones'] && data['versiones'].length > 0) {
         setVersiones(data['versiones']);
         setCampo('version', data['versiones'][0].codigo);
      }
      if (data['modulares'] && data['modulares'].length > 0) {
         setModulares(data['modulares']);
         setCampo('modular', data['modulares'][0].codigo);
      }
   }
   const { data: dataGenerica } = useApolloQ(queryData, {
      callbackProcesarData: procesarDataGenerica,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });
   //Datos del cliente
   const [grupo, setGrupo] = useState(0);
   function getClienteCodigo(valor) {
      return valor.split('|')[0];
   }
   function getClienteEmail(valor) {
      if (valor) {
         return valor.split('|')[1];
      }
      return '';
   }
   function procesarGrupo(data) {
      if (data['maxGrupoCliente'] && data['maxGrupoCliente'].length > 0) {
         setGrupo(data['maxGrupoCliente'][0].grupo);
      }
   }
   const [getGrupo] = useApolloLazyQ(queryGrupoCliente, {
      callbackProcesarData: procesarGrupo,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });
   /********* */
   function procesarDataGenericaVersion(data) {
      if (
         data.productoDetallesOrdDesFechaCreacion &&
         data.productoDetallesOrdDesFechaCreacion.length > 0
      ) {
         const objetoVersiones = data.productoDetallesOrdDesFechaCreacion.reduce(
            (Acumulador, valorActual, Indice) => {
               Acumulador[valorActual.version.codigo] = valorActual.version;
               return Acumulador;
            },
            {}
         );
         const arrayVersiones = Object.values(objetoVersiones);
         if (arrayVersiones.length != 0) {
            setCampo('version', arrayVersiones[0].codigo);
            setVersiones(Object.values(arrayVersiones));
         } else {
            setCampo('version', arrayVersiones);
            setVersiones(Object.values(arrayVersiones));
         }
      }
   }
   function procesarDataGenericaPresentacion() {
      if (DatosFiltro && DatosFiltro?.productoDetallesOrdDesFechaCreacion.length > 0) {
         setDisable(false);
         let arrayPresentacion = [];
         DatosFiltro.productoDetallesOrdDesFechaCreacion.forEach(element => {
            if (element.version.codigo === campos.version.valor) {
               arrayPresentacion.push(element.presentacion);
            }
         });
         if (arrayPresentacion.length != 0) {
            setCampo('presentacion', arrayPresentacion[0].codigo);
            setPresentaciones(arrayPresentacion);
         } else {
            setCampo('presentacion', arrayPresentacion);
            setPresentaciones(arrayPresentacion);
         }
      }
   }
   const [getVersion, { data: DatosFiltro }] = useApolloLazyQ(queryDataVer, {
      callbackProcesarData: procesarDataGenericaVersion,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });
   useEffect(() => {
      if (campos.producto.valor) {
         const variables = {
            codigoProducto: campos.producto.valor
         };
         getVersion({ variables: variables });
      }
   }, [campos.producto.valor]);
   useEffect(() => {
      if (campos.version.valor) {
         procesarDataGenericaPresentacion();
      }
   }, [campos.version.valor]);
   /********* */
   useEffect(() => {
      if (campos.cliente.valor && campos.cliente.valor.value !== '') {
         getGrupo({ variables: { codigoCliente: getClienteCodigo(campos.cliente.valor.value) } });
      }
   }, [campos.cliente.valor]);
   //Generacion de Códigos de Activación
   async function generarLlaves() {
      const esDataOk = await validarTodos();
      if (esDataOk) {
         let nuevasLlaves = [];
         const producto = productos.filter(item => item.codigo === campos.producto.valor)[0];
         const version = versiones.filter(item => item.codigo === campos.version.valor)[0];
         const presentacion = presentaciones.filter(
            item => item.codigo === campos.presentacion.valor
         )[0];
         const modular = modulares.filter(item => item.codigo === campos.presentacion.valor)[0];
         for (let index = 0; index < campos.nroLlaves.valor; index++) {
            const nuevaLllave = {
               codigo: uuidv4(),
               producto,
               version,
               presentacion,
               modular,
               anio: campos.anio.valor,
               fechaExpiracion: campos.fechaExpiracion.valor,
               fechaVigenciaApi: campos.fechaVigenciaApi.valor,
               fechaVigenciaSoporte: campos.fechaVigenciaSoporte.valor,
               //agregar fecha de vigencia para apis
               grupo
            };
            nuevasLlaves.push(nuevaLllave);
         }
         setLlaves([...llaves, ...nuevasLlaves]);
      }
   }
   function eliminarLlaveLista(indexAeliminar) {
      if (indexAeliminar === -1) {
         setLlaves([]);
      } else {
         const llavesNuevas = llaves.filter((item, index) => {
            return indexAeliminar !== index;
         });
         setLlaves(llavesNuevas);
      }
   }
   const [llaves, setLlaves] = useState([]);

   //Grabar las licencias generadas
   const [grabarLicencias] = useApolloMutation(mutationGenerarLicencia, {
      callbackProcesarData: procesarGenerarLicenciaData,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });
   const [exitoGrabar, setExitoGrabar] = useState(false);
   async function generarParametros() {
      let parametrosSpu = {
         ruc: getClienteCodigo(campos.cliente.valor.value),
         razonsocial: campos.razonSocial.valor,
         tipoDoc: campos.tipoDoc.valor,
         serieDoc: campos.serieDoc.valor,
         nroDoc: campos.nroDoc.valor,
         usuario: usuario.usuario
      };
      const activacionesDatos = await Promise.all(
         llaves.map(item => {
            return {
               codigo: item.codigo,
               grupo: item.grupo,
               anio: item.anio,
               producto: item.producto.codigo,
               version: item.version.codigo,
               presentacion: item.presentacion.codigo,
               modular: item.modular,
               fechaExpiracion: item.fechaExpiracion
                  ? `${item.fechaExpiracion.getFullYear()}-${item.fechaExpiracion.getMonth() +
                  1}-${item.fechaExpiracion.getDate()}`
                  : null,
               fechaVigenciaApi: item.fechaVigenciaApi
                  ? `${item.fechaVigenciaApi.getFullYear()}-${item.fechaVigenciaApi.getMonth() +
                  1}-${item.fechaVigenciaApi.getDate()}`
                  : null,
               fechaVigenciaSoporte: item.fechaVigenciaSoporte
                  ? `${item.fechaVigenciaSoporte.getFullYear()}-${item.fechaVigenciaSoporte.getMonth() +
                  1}-${item.fechaVigenciaSoporte.getDate()}`
                  : null
            };
         })
      );
      parametrosSpu.activaciones = activacionesDatos;
      return parametrosSpu;
   }
   async function procesarGrabar() {
      const esOkGrabar = await validarTodos();
      if (esOkGrabar) {
         const variables = await generarParametros();
         grabarLicencias({ variables });
      }
   }
   async function procesarGenerarLicenciaData(data) {
      if (data['generarLicencia'] && data['generarLicencia'].msg !== '') {
         showSucces(data['generarLicencia'].msg);
         setExitoGrabar(true);
      }
   }

   //Enviar mensaje con las llaves
   function procesarMensajeCorrecto() {
      showSucces('Correo electrónico enviado correctamente.');
   }
   const [enviarMailLlave] = useMensajeLlave({
      callbackProcesarData: procesarMensajeCorrecto,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });
   async function enviarEmail(para) {
      let receptores = [];
      const receptor = {
         email: cadenas.removeSpaces(para),
         ruc: getClienteCodigo(campos.cliente.valor.value),
         razonSocial: campos.razonSocial.valor,
         documento: `${campos.tipoDoc.valor}-${campos.serieDoc.valor}-${campos.nroDoc.valor}`,
         producto: campos.producto.valor
      };

      receptor.activaciones = await Promise.all(
         llaves.map(item => {
            return `${item.codigo} (${item.producto.denominacion} ${item.presentacion.denominacion} ${item.version.denominacion})`;
         })
      );
      receptores.push(receptor);
      enviarMailLlave({ variables: { receptores } });
   }
   //Estados de control

   //Funciones
   function inicializarCombos(data) {
      if (!validacion.esVarNullUndef(data)) {
         if (data['productos'] && data['productos'].length > 0) {
            setCampo('producto', data['productos'][0].codigo);
         }
         if (data['presentaciones'] && data['presentaciones'].length > 0) {
            setCampo('presentacion', data['presentaciones'][0].codigo);
         }
         if (data['versiones'] && data['versiones'].length > 0) {
            setCampo('version', data['versiones'][0].codigo);
         }
         if (data['modulares'] && data['modulares'].length > 0) {
            setCampo('modular', data['modulares'][0].codigo);
         }
      }
   }
   function inicializarFormulario() {
      inicializar();
      inicializarCombos(dataGenerica);
      setLlaves([]);
      setGrupo(0);
      setExitoGrabar(false);
   }
   return (
      // <Container className={clsx(classes.container, 'containerbox')} maxWidth="md">
      <Container className={cx('containerbox', classes.container)} maxWidth="md">
         <Grid container spacing={1}>
            <Grid item xs={12}>
               <Typography variant="h4" gutterBottom align="center">
                  Generar Llave Virtual
               </Typography>
            </Grid>
            <Grid container item xs={12}>
               <GroupBox label="Datos Empresa" fullWidth>
                  <Grid container spacing={1}>
                     <Grid item xs={5}>
                        <SelectPlus
                           url={urlsCrm.graph}
                           name={cmps.CLIENTE}
                           label="RUC"
                           entidad="clientes"
                           campos={[
                              'codigo',
                              'nombre',
                              'apPaterno',
                              'apMaterno',
                              'razonSocial',
                              'nroDoc',
                              'email'
                           ]}
                           value={campos.cliente.valor}
                           onChange={elegido => {
                              validacionManual(cmps.CLIENTE, elegido);
                              if (elegido) {
                                 const emailRecuperado = cadenas.removeSpaces(
                                    getClienteEmail(elegido.value)
                                 );
                                 setEmail(emailRecuperado);
                                 validacionManual(cmps.EMAIL_OTRO, emailRecuperado);
                              }
                           }}
                           genId={registro => {
                              return `${registro.nroDoc}|${registro.email}`;
                           }}
                           genLabel={denominacionCliente}
                           error={campos.cliente.error !== ''}
                           helperText={campos.cliente.error}
                           InputLabelProps={{ shrink: true }}
                           variant="outlined"
                           margin="dense"
                           fullWidth
                           isClearable
                           excesoElementos
                           recuperarOnFocus
                           required
                           disabled={llaves.length > 0}
                           placeholder="Elija un cliente:"
                        />
                     </Grid>
                     <Grid item xs={7}>
                        <TextField
                           label="Razón Social"
                           name={cmps.RAZON_SOCIAL}
                           variant="outlined"
                           margin="dense"
                           fullWidth
                           required
                           onChange={handleOnChange}
                           onBlur={onBlurValidacion}
                           value={campos.razonSocial.valor}
                           error={campos.razonSocial.error !== ''}
                           helperText={campos.razonSocial.error}
                           disabled={llaves.length > 0}
                        />
                     </Grid>
                     {email && (
                        <Grid item xs={12}>
                           <Typography>
                              <strong>E-Mail: </strong>
                              {`${email}`}
                           </Typography>
                        </Grid>
                     )}
                  </Grid>
               </GroupBox>
            </Grid>
            <Grid container item xs={12}>
               <GroupBox label="Documento" fullWidth>
                  <Grid container spacing={1}>
                     <Grid item xs={3}>
                        <SelectDs
                           id="selectTipoDoc"
                           name={cmps.TIPO_DOC}
                           label="Tipo"
                           variant="outlined"
                           value={campos.tipoDoc.valor}
                           onChange={handleOnChange}
                           margin="dense"
                           data={tiposDocumento}
                           error={campos.tipoDoc.error !== ''}
                           helperText={campos.tipoDoc.error}
                           required
                           fullWidth
                           disabled={llaves.length > 0}
                        />
                     </Grid>
                     <Grid item xs={3}>
                        <TextField
                           label="Serie"
                           name={cmps.SERIE_DOC}
                           variant="outlined"
                           margin="dense"
                           fullWidth
                           required
                           onChange={handleOnChange}
                           onBlur={onBlurValidacion}
                           value={campos.serieDoc.valor}
                           error={campos.serieDoc.error !== ''}
                           helperText={campos.serieDoc.error}
                           disabled={llaves.length > 0}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TextField
                           label="Número"
                           name={cmps.NRO_DOC}
                           variant="outlined"
                           margin="dense"
                           fullWidth
                           required
                           onChange={handleOnChange}
                           onBlur={onBlurValidacion}
                           value={campos.nroDoc.valor}
                           error={campos.nroDoc.error !== ''}
                           helperText={campos.nroDoc.error}
                           disabled={llaves.length > 0}
                        />
                     </Grid>
                  </Grid>
               </GroupBox>
            </Grid>
            <Grid container item xs={12}>
               <GroupBox label="Datos de los Código de Activación">
                  <Grid container spacing={1} alignItems="center">
                     <Grid item xs={4}>
                        <SelectDs
                           id="selectProducto"
                           name={cmps.PRODUCTO}
                           label="Producto"
                           variant="outlined"
                           value={campos.producto.valor}
                           onChange={handleOnChange}
                           margin="dense"
                           data={productos}
                           error={campos.producto.error !== ''}
                           helperText={campos.producto.error}
                           genItemValue={genValue}
                           genItemKey={genId}
                           genItemLabel={genLabel}
                           required
                           fullWidth
                        />
                     </Grid>
                     <Grid item xs={4}>
                        <SelectDs
                           id="selectVersion"
                           name={cmps.VERSION}
                           label="Versión"
                           variant="outlined"
                           value={campos.version.valor}
                           onChange={handleOnChange}
                           margin="dense"
                           data={versiones}
                           error={campos.version.error !== ''}
                           helperText={campos.version.error}
                           genItemValue={genValue}
                           genItemKey={genId}
                           genItemLabel={genLabel}
                           required
                           fullWidth
                        />
                     </Grid>
                     <Grid item xs={4}>
                        <SelectDs
                           id="selectPresentacion"
                           name={cmps.PRESENTACION}
                           label="Presentación"
                           variant="outlined"
                           value={campos.presentacion.valor}
                           onChange={handleOnChange}
                           margin="dense"
                           data={presentaciones}
                           error={campos.presentacion.error !== ''}
                           helperText={campos.presentacion.error}
                           genItemValue={genValue}
                           genItemKey={genId}
                           genItemLabel={genLabel}
                           required
                           fullWidth
                        />
                     </Grid>
                     {/**
                     <Grid item xs={3}>
                        <SelectDs
                           id="selectModular"
                           name={cmps.MODULAR}
                           label="Modular"
                           variant="outlined"
                           value={campos.modular.valor}
                           onChange={handleOnChange}
                           margin="dense"
                           data={modulares}
                           error={campos.modular.error !== ''}
                           helperText={campos.modular.error}
                           genItemValue={genValue}
                           genItemKey={genId}
                           genItemLabel={genLabel}
                           fullWidth
                        />
                     </Grid>
                     */}
                     <Grid item xs={2}>
                        <TextField
                           label="Año"
                           name={cmps.ANIO}
                           variant="outlined"
                           margin="dense"
                           type="number"
                           fullWidth
                           required
                           onChange={handleOnChange}
                           onBlur={onBlurValidacion}
                           value={campos.anio.valor}
                           error={campos.anio.error !== ''}
                           helperText={campos.anio.error}
                           InputLabelProps={{
                              shrink: true
                           }}
                        />
                     </Grid>
                     <Grid container item spacing={1} xs={8}>
                        <Grid item xs={4}>
                           <DatePicker
                              name={cmps.FECHA_EXPIRACION}
                              margin="dense"
                              label="Fecha Expiración"
                              format="dd/MM/yyyy"
                              value={campos.fechaExpiracion.valor}
                              onChange={date => {
                                 validacionManual(cmps.FECHA_EXPIRACION, date);
                                 validacionManual(cmps.FECHA_VIGENCIA_API, date);
                                 validacionManual(cmps.FECHA_VIGENCIA_SOPORTE, date);
                              }}
                              inputVariant="outlined"
                              KeyboardButtonProps={{
                                 'aria-label': 'elegir fecha'
                              }}
                              minDate={new Date()}
                              fullWidth
                           />
                        </Grid>
                        <Grid item xs={4}>
                           <DatePicker
                              name={cmps.FECHA_VIGENCIA_API}
                              margin="dense"
                              label="Fecha Fin APIs"
                              format="dd/MM/yyyy"
                              value={campos.fechaVigenciaApi.valor}
                              onChange={date => {
                                 validacionManual(cmps.FECHA_VIGENCIA_API, date);
                              }}
                              inputVariant="outlined"
                              KeyboardButtonProps={{
                                 'aria-label': 'elegir fecha'
                              }}
                              minDate={new Date()}
                              fullWidth
                           />
                        </Grid>
                        <Grid item xs={4}>
                           <DatePicker
                              name={cmps.FECHA_VIGENCIA_SOPORTE}
                              margin="dense"
                              label="Fecha Fin Soporte"
                              format="dd/MM/yyyy"
                              value={campos.fechaVigenciaSoporte.valor}
                              onChange={date => {
                                 validacionManual(cmps.FECHA_VIGENCIA_SOPORTE, date);
                              }}
                              inputVariant="outlined"
                              KeyboardButtonProps={{
                                 'aria-label': 'elegir fecha'
                              }}
                              minDate={new Date()}
                              fullWidth
                              slotProps={{ textField: { required: true } }}
                           />
                        </Grid>
                     </Grid>
                     <Grid item xs={2}>
                        <TextField
                           label={cmps.NRO_LLAVES}
                           name="nroLlaves"
                           variant="outlined"
                           margin="dense"
                           type="number"
                           fullWidth
                           onChange={handleOnChange}
                           value={campos.nroLlaves.valor}
                           inputProps={{ min: 1 }}
                           InputLabelProps={{
                              shrink: true
                           }}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <Button
                           variant="contained"
                           onClick={generarLlaves}
                           fullWidth
                           disabled={existeError || exitoGrabar}
                        >
                           Generar Llaves
                        </Button>
                     </Grid>
                  </Grid>
               </GroupBox>
            </Grid>
            <Grid container item xs={12}>
               <GroupBox label="Códigos de Activación">
                  <Grid container spacing={2} alignItems="flex-start">
                     <Grid item xs={8}>
                        <Button
                           variant="contained"
                           fullWidth
                           disabled={llaves.length === 0}
                           onClick={procesarGrabar}
                        >
                           Grabar
                        </Button>
                     </Grid>
                     <Grid item xs={4}>
                        <Button variant="contained" onClick={inicializarFormulario} fullWidth>
                           Nuevo
                        </Button>
                     </Grid>
                     {/*exitoGrabar*/ true && (
                        <Grid container item xs={12} spacing={1} alignItems="center">
                           <Grid item xs={6}>
                              <TextField
                                 label="Email"
                                 name={cmps.EMAIL_OTRO}
                                 variant="outlined"
                                 margin="dense"
                                 fullWidth
                                 onChange={handleOnChange}
                                 onBlur={onBlurValidacion}
                                 value={campos.emailOtro.valor}
                                 error={campos.emailOtro.error !== ''}
                                 helperText={campos.emailOtro.error}
                              />
                           </Grid>
                           <Grid item xs={6}>
                              <Button
                                 variant="contained"
                                 onClick={() => enviarEmail(campos.emailOtro.valor)}
                                 fullWidth
                                 disabled={
                                    llaves.length === 0 ||
                                    campos.emailOtro.error !== '' ||
                                    campos.emailOtro.valor === ''
                                 }
                              >
                                 Enviar Email a {campos.emailOtro.valor}
                              </Button>
                           </Grid>
                        </Grid>
                     )}
                     <Grid container item xs={12} spacing={1}>
                        <TableContainer component={Paper}>
                           <Table size="small">
                              <TableHead>
                                 <TableRow>
                                    <TableCell>Nro.</TableCell>
                                    <TableCell>Llave</TableCell>
                                    <TableCell>Producto</TableCell>
                                    <TableCell>Presen.</TableCell>
                                    <TableCell>Ver.</TableCell>
                                    <TableCell>
                                       <IconButton
                                          size="small"
                                          onClick={() => {
                                             eliminarLlaveLista(-1);
                                          }}
                                          color='primary'
                                       >
                                          <DeleteForeverIcon />
                                       </IconButton>
                                    </TableCell>
                                 </TableRow>
                              </TableHead>
                              <TableBody>
                                 {llaves.map((llave, index) => {
                                    return (
                                       <TableRow key={llave.codigo}>
                                          <TableCell component="th" scope="row">
                                             {index + 1}
                                          </TableCell>
                                          <TableCell component="th" scope="row">
                                             {llave.codigo}
                                          </TableCell>
                                          <TableCell>{llave.producto.denominacion}</TableCell>
                                          <TableCell>{llave.presentacion.denominacion}</TableCell>
                                          <TableCell>{llave.version.denominacion}</TableCell>
                                          <TableCell>
                                             <IconButton
                                                size="small"
                                                onClick={() => {
                                                   eliminarLlaveLista(index);
                                                }}
                                             >
                                                <DeleteOutlineIcon />
                                             </IconButton>
                                          </TableCell>
                                       </TableRow>
                                    );
                                 })}
                              </TableBody>
                           </Table>
                        </TableContainer>
                     </Grid>
                  </Grid>
               </GroupBox>
            </Grid>
         </Grid>
      </Container>
   );
}

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps(dispatch) {
   return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(GenerarLicencia);
